import { ReactElement } from 'react';
import { useAuth } from 'contexts/AuthContext';
import { createBrowserRouter, Navigate } from 'react-router-dom';
import RootLayout from '../layouts/RootLayout';
import AuthLayout from '../layouts/AuthLayout';
import LandingPage from '../pages/LandingPage';
import PropertySelection from '../pages/PropertySelection';
import OAuthCallback from 'pages/OAuthCallback';

type AuthGuardProps = {
  children: ReactElement;
};

function AuthGuard({ children }: Readonly<AuthGuardProps>) {
  const { isAuthenticated } = useAuth();
  if (!isAuthenticated) return <Navigate to="/" />;
  return children;
}
const appRouter = () =>
  createBrowserRouter([
    {
      path: '/',
      element: <RootLayout />,
      children: [
        {
          index: true,
          element: <LandingPage />,
        },
        {
          path: 'oauth/callback',
          element: <OAuthCallback />,
        },
        {
          element: (
            <AuthGuard>
              <AuthLayout />
            </AuthGuard>
          ),
          children: [
            {
              path: 'property-selection',
              element: <PropertySelection />,
            },
          ],
        },
      ],
    },
  ]);

export default appRouter;
